<template>
  <el-card class="seedling">
    <el-form class="global-form2" :model="formData" ref="form" label-width="120px">
      <el-form-item label="考核对象" prop="resultTitle">
        {{ formData.resultTitle }}
      </el-form-item>
      <el-form-item label="考核日期" prop="resultDate">
        {{ formData.resultDate }}
      </el-form-item>
      <el-form-item label="考核工单" prop="issueIds">
        <el-table class="global-table" v-loading="loading" :data="issueList">
          <el-table-column label="所属项目" show-overflow-tooltip prop="projectName"></el-table-column>
          <el-table-column label="考核大项" show-overflow-tooltip prop="assessmentTypeName"></el-table-column>
          <el-table-column label="考核细则编号" show-overflow-tooltip prop="scoreNo"></el-table-column>
          <el-table-column label="工单详情" show-overflow-tooltip prop="issueContent"></el-table-column>
          <el-table-column label="提交时间" show-overflow-tooltip prop="ctime"></el-table-column>
          <el-table-column label="当前节点" show-overflow-tooltip prop="taskName"></el-table-column>
          <el-table-column label="扣分情况" show-overflow-tooltip prop="score"></el-table-column>
          <el-table-column label="工单状态" show-overflow-tooltip prop="issueStatus">
            <template v-slot="{ row }">{{ orderStatusMap.get(row.issueStatus) }}</template>
          </el-table-column>
          <el-table-column label="已耗时" show-overflow-tooltip prop="time"></el-table-column>
          <el-table-column label="操作" width="200px" fixed="right">
            <template v-slot="{ row }">
              <el-button type="text" v-if="row.processId && row.isDel === 0" @click="showProcess(row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item label="得分合计">
        {{ formData.resultScore }}
      </el-form-item>
    </el-form>

    <el-drawer :size="'500px'" direction="rtl" title="审批详情" :visible.sync="processVisible">
      <instance-preview v-if="processVisible" :instance-id="selectInstance.instanceId"
        @handler-after="handlerAfter"></instance-preview>
    </el-drawer>
  </el-card>
</template>

<script>
import { orderStatus } from '@/utils/dict'
import InstancePreview from '@/views/wflow/workspace/approval/ProcessInstancePreview'
export default {
  name: 'AssessmentResultsDetail',
  components: { InstancePreview },
  data() {
    return {
      processVisible: false,
      selectInstance: {
        instanceId: '',
        nodeId: ''
      },
      loading: false,
      formData: {
        resultTitle: '', // 考核结果对象
        resultDate: '', // 考核结果日期
        resultScore: '', // 考核结果得分
        issueIds: [] // 考核问题ID集合
      },
      page: 1,
      size: 10,
      total: 0,
      issueList: [],
      orderStatusMap: orderStatus
    }
  },
  computed: {
    resultId() {
      return this.$route.query.resultId
    }
  },
  created() {
    this.loadData()
    this.loadData2()
  },
  methods: {
    loadData() {
      return this.$axios.get(this.$apis.assessmentScore.selectAssessmentResultByResultId, {
        resultId: this.resultId
      }).then((res) => {
        this.formData = res || {}
      })
    },
    loadData2() {
      this.loading = true
      this.$axios.get(this.$apis.assessmentScore.selectLcAssessmentIssueByPage, {
        page: this.page,
        size: this.size,
        resultId: this.resultId
      }).then((res) => {
        this.issueList = res.list || []
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },
    showProcess(row) {
      this.processVisible = true
      this.selectInstance = {
        instanceId: row.processId,
        nodeId: row.nodeId
      }
    },
    handlerAfter() {
      this.processVisible = false
    }
  }
}
</script>

<style scoped lang="scss"></style>
